// extracted by mini-css-extract-plugin
module.exports = {"media":"EquipmentModalMedia_media__vseHT","caption":"EquipmentModalMedia_caption__q36KX","override-figure":"EquipmentModalMedia_override-figure__B_I_F"};